export function toSnakeCase(text: string) {
  return (
    text
      // split lower-to-upper (e.g. "fooBar" → "foo_Bar")
      .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
      // split acronym boundaries (e.g. "getURL" → "get_URL")
      .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
      // split letter-to-number (e.g. "rma12" → "rma_12")
      .replace(/([A-Za-z])([0-9])/g, '$1_$2')
      // split number-to-letter (e.g. "12things" → "12_things")
      .replace(/([0-9])([A-Za-z])/g, '$1_$2')
      .toLowerCase()
  );
}
